import React from 'react';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { Icon } from '../ui/icon';
import { Z_INDEX } from './app-sidebar/constants';

export const ORG_CONTEXT_BANNER_HEIGHT_PX = 44;

function buildSwitchOrgUrl(): string {
  return `${NEW_ADMIN_BASE_URL}/superkudu/tenants`;
}

export function OrgContextBanner({ tenantId }: { tenantId: string }) {
  return (
    <div
      id="org-context-banner"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: `${ORG_CONTEXT_BANNER_HEIGHT_PX}px`,
        zIndex: Z_INDEX.SIDEBAR_MAIN + 1,
        backgroundColor: 'var(--hg-coral)',
        color: 'var(--hg-navy)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
        fontFamily: 'var(--hg-font-body)',
      }}
      role="status"
      aria-live="polite"
    >
      <div
        style={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          padding: '0 16px',
        }}
      >
        <div
          style={{
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontSize: '12px',
            lineHeight: '20px',
            fontWeight: 400,
          }}
        >
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              whiteSpace: 'nowrap',
            }}
          >
            <Icon
              icon={faTriangleExclamation}
              style={{
                color: 'orange',
                flexShrink: 0,
                opacity: 0.95,
                height: '1em',
                width: '1em',
                lineHeight: '1em',
                display: 'inline-block',
                marginTop: '-1px',
              }}
            />
            <span id="org-context-banner-message">
              You are impersonating <b>a user</b> on organization{' '}
              <b>{tenantId}</b>
            </span>
          </span>
        </div>

        <a
          id="org-context-banner-switch-org"
          href={buildSwitchOrgUrl()}
          style={{
            position: 'absolute',
            right: 16,
            color: 'inherit',
            textTransform: 'uppercase',
            fontSize: '12px',
            fontWeight: 700,
            letterSpacing: '0.02857em',
            textDecoration: 'none',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.textDecoration = 'underline';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.textDecoration = 'none';
          }}
        >
          Switch org
        </a>
      </div>
    </div>
  );
}
